import { LANGUAGE_CODES, getLanguageConfig, normalizeLanguage } from '../i18n/languages';

const BASE_URL = 'https://www.miamitoursandtravel.com';

export { normalizeLanguage };

function splitPathParts(path = '/') {
  const rawValue = String(path || '/');
  const hashIndex = rawValue.indexOf('#');
  const pathAndQuery = hashIndex >= 0 ? rawValue.slice(0, hashIndex) : rawValue;
  const hash = hashIndex >= 0 ? rawValue.slice(hashIndex) : '';
  const queryIndex = pathAndQuery.indexOf('?');
  const pathname = queryIndex >= 0 ? pathAndQuery.slice(0, queryIndex) : pathAndQuery;
  const search = queryIndex >= 0 ? pathAndQuery.slice(queryIndex) : '';

  return {
    pathname: pathname || '/',
    search,
    hash,
  };
}

export function getPathLanguage(pathname = '/') {
  const normalizedPath = splitPathParts(pathname).pathname;
  const matchedLanguage = LANGUAGE_CODES.find((language) => {
    const { prefix } = getLanguageConfig(language);
    return prefix && (normalizedPath === prefix || normalizedPath.startsWith(`${prefix}/`));
  });
  if (matchedLanguage) return matchedLanguage;
  return 'en';
}

export function stripLanguagePrefix(path = '/') {
  const { pathname, search, hash } = splitPathParts(path);
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  let strippedPath = normalizedPath;

  const matchingPrefix = LANGUAGE_CODES
    .map((language) => getLanguageConfig(language).prefix)
    .find((prefix) => prefix && (normalizedPath === prefix || normalizedPath.startsWith(`${prefix}/`)));

  if (matchingPrefix) {
    strippedPath = normalizedPath.slice(matchingPrefix.length) || '/';
  }

  return `${strippedPath}${search}${hash}`;
}

export function localizePath(path = '/', language = 'en') {
  const normalizedLanguage = normalizeLanguage(language);
  const { pathname, search, hash } = splitPathParts(stripLanguagePrefix(path));
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const prefix = getLanguageConfig(normalizedLanguage).prefix;
  const localizedPath = prefix
    ? normalizedPath === '/'
      ? prefix
      : `${prefix}${normalizedPath}`
    : normalizedPath;

  return `${localizedPath}${search}${hash}`;
}

export function buildSiteUrl(path = '/', language = 'en') {
  return `${BASE_URL}${localizePath(path, language)}`;
}
